// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cart-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 1.5rem;
}

.cart-container h1 {
  margin-bottom: 1.5rem;
  color: #24292e;
  font-size: 1.75rem;
  font-weight: 600;
}

.error-message {
  background-color: #fee;
  color: #c33;
  padding: 10px 15px;
  border-radius: 4px;
  margin-bottom: 20px;
}

.success-message {
  background-color: #efe;
  color: #363;
  padding: 20px;
  border-radius: 4px;
  margin-bottom: 20px;
}

.success-message h3 {
  margin-top: 0;
  color: #363;
}

.empty-cart {
  text-align: center;
  padding: 60px 20px;
  color: #666;
}

/* Bundled Items Styling */
.bundled-notice {
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  padding: 0.875rem 1rem;
  margin-bottom: 1.25rem;
  display: flex;
  align-items: flex-start;
  gap: 10px;
}

.bundled-notice i {
  color: #6c757d;
  font-size: 1.1rem;
  margin-top: 2px;
}

.bundled-notice-content {
  flex: 1 1;
}

.bundled-notice-title {
  font-weight: 600;
  color: #495057;
  margin-bottom: 0.25rem;
  font-size: 0.95rem;
}

.bundled-notice-text {
  color: #6c757d;
  font-size: 0.85rem;
  margin: 0;
  line-height: 1.4;
}

/* Bundled Item Card */
.card.bundled-item {
  background: #fafbfc !important;
  border: 1px solid #e1e4e8 !important;
  border-left: 3px solid #6c757d !important;
  margin-left: 0.5rem;
}

.bundled-badge {
  background: #6c757d !important;
  color: white !important;
  font-size: 0.7rem;
  padding: 0.2rem 0.4rem;
  border-radius: 3px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.bundled-info {
  color: #6c757d;
  font-size: 0.8rem;
  font-style: normal;
  opacity: 0.9;
}

/* Table row for bundled items */
tr.bundled-row {
  background-color: #fafbfc !important;
}

tr.bundled-row td {
  border-left: none;
  padding-left: 2rem;
  position: relative;
}

tr.bundled-row td:first-child::before {
  content: "";
  position: absolute;
  left: 0.75rem;
  top: 50%;
  transform: translateY(-50%);
  width: 3px;
  height: 60%;
  background: #6c757d;
  border-radius: 2px;
}

/* Fix yellow-on-yellow issue */
.badge.bg-warning {
  background-color: #495057 !important;
  color: white !important;
}

.table-warning {
  background-color: #f8f9fa !important;
}

.border-warning {
  border-color: #dee2e6 !important;
}

/* Checkout/Draft Info Box */
.checkout-info-box {
  background-color: #f8f9fa;
  border: 1px solid #e1e4e8;
  border-radius: 6px;
  padding: 0.875rem 1rem;
  margin-top: 0.75rem;
}

.checkout-info-content {
  font-size: 0.8rem;
  color: #586069;
  line-height: 1.5;
}

.checkout-info-row {
  display: flex;
  align-items: flex-start;
  margin-bottom: 0.4rem;
  gap: 0.5rem;
}

.checkout-info-row:last-child {
  margin-bottom: 0;
}

.checkout-info-label {
  min-width: 70px;
  font-weight: 600;
  color: #24292e;
  font-size: 0.8rem;
}

.checkout-info-text {
  flex: 1 1;
  color: #586069;
  font-size: 0.8rem;
}

.cart-items {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  margin-bottom: 20px;
}

.cart-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #eee;
}

.cart-item:last-child {
  border-bottom: none;
}

.item-info h3 {
  margin: 0 0 8px 0;
  color: #333;
}

.item-info p {
  margin: 4px 0;
  color: #666;
  font-size: 14px;
}

.item-info .price {
  color: #1976d2;
  font-weight: 500;
}

.item-controls {
  display: flex;
  align-items: center;
  gap: 30px;
}

.quantity-controls {
  display: flex;
  align-items: center;
  gap: 10px;
}

.quantity-controls button {
  width: 30px;
  height: 30px;
  border: 1px solid #ddd;
  background: white;
  border-radius: 4px;
  cursor: pointer;
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.quantity-controls button:hover:not(:disabled) {
  background-color: #f5f5f5;
}

.quantity-controls button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.quantity {
  min-width: 40px;
  text-align: center;
  font-weight: 500;
}

.item-subtotal {
  min-width: 100px;
  text-align: right;
  font-weight: 500;
  font-size: 18px;
  color: #333;
}

.remove-btn {
  background: none;
  border: none;
  color: #c33;
  cursor: pointer;
  padding: 5px 10px;
  text-decoration: underline;
}

.remove-btn:hover {
  color: #a22;
}

.cart-summary {
  background: white;
  border-radius: 6px;
  border: 1px solid #e1e4e8;
  box-shadow: 0 1px 3px rgba(0,0,0,0.06);
  padding: 1.25rem;
  max-width: 400px;
  margin-left: auto;
}

.summary-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  color: #666;
}

.summary-row.total {
  margin-top: 20px;
  padding-top: 20px;
  border-top: 2px solid #eee;
  font-size: 20px;
  font-weight: 500;
  color: #333;
}

.cart-actions {
  margin-top: 30px;
}

.create-quote-btn {
  width: 100%;
  padding: 0.625rem 1rem;
  background-color: #0066cc;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.create-quote-btn:hover {
  background-color: #0052a3;
  box-shadow: 0 2px 4px rgba(0,102,204,0.2);
}

/* Modal Styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  padding: 30px;
  border-radius: 8px;
  max-width: 500px;
  width: 90%;
  max-height: 90vh;
  overflow-y: auto;
}

.modal-content h2 {
  margin-top: 0;
  margin-bottom: 20px;
  color: #333;
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  color: #666;
  font-weight: 500;
}

.form-group textarea {
  width: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  resize: vertical;
  font-family: inherit;
}

.modal-actions {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  margin-top: 30px;
}

.modal-actions button {
  padding: 10px 20px;
  border: 1px solid #ddd;
  background: white;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}

.modal-actions button.primary {
  background-color: #1976d2;
  color: white;
  border-color: #1976d2;
}

.modal-actions button:hover:not(:disabled) {
  opacity: 0.9;
}

.modal-actions button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.loading {
  text-align: center;
  padding: 40px;
  color: #666;
}

.error {
  text-align: center;
  padding: 40px;
  color: #c33;
}

/* Inline Quantity Editor Styles */
.quantity-edit-wrapper {
  position: relative;
}

.quantity-edit-wrapper .input-group {
  box-shadow: 0 2px 8px rgba(0,0,0,0.15);
  border-radius: 4px;
  overflow: hidden;
}

.quantity-edit-wrapper input[type="number"] {
  border-right: none;
  font-weight: 500;
  font-size: 16px;
}

.quantity-edit-wrapper input[type="number"]:focus {
  box-shadow: none;
  border-color: #1976d2;
}

.quantity-edit-wrapper .btn-success {
  border-left: 1px solid #e0e0e0;
  border-radius: 0;
}

.quantity-edit-wrapper .btn-secondary {
  border-left: 1px solid #e0e0e0;
  border-radius: 0 4px 4px 0;
}

.quantity-display {
  cursor: pointer;
  padding: 4px 12px;
  border-radius: 4px;
  transition: all 0.2s ease;
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  -webkit-user-select: none;
          user-select: none;
}

.quantity-display:hover {
  background-color: #f0f0f0;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
}

.quantity-display .fa-edit {
  opacity: 0;
  transition: opacity 0.2s;
}

.quantity-display:hover .fa-edit {
  opacity: 0.7;
}

.quantity-updating {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 60px;
  padding: 4px 12px;
}

/* Product Link Styles */
.cart-product-link {
  text-decoration: none;
  transition: all 0.2s ease;
}

.cart-product-link:hover {
  text-decoration: underline;
  opacity: 0.85;
}

.cart-product-link h6 {
  transition: color 0.2s ease;
}

.cart-product-link:hover h6 {
  color: #1565c0 !important;
}`, "",{"version":3,"sources":["webpack://./src/components/Cart.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA,0BAA0B;AAC1B;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;EACtB,sBAAsB;EACtB,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;EACvB,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;AACd;;AAEA,gCAAgC;AAChC;EACE,oCAAoC;AACtC;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,QAAQ;EACR,2BAA2B;EAC3B,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,+BAA+B;AAC/B;EACE,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,gCAAgC;AAClC;;AAEA,4BAA4B;AAC5B;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,sCAAsC;EACtC,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;;AAEA,kCAAkC;AAClC;EACE,kBAAkB;AACpB;;AAEA;EACE,sCAAsC;EACtC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,qCAAqC;AACvC;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;AACnB;;AAEA,wBAAwB;AACxB;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,aAAa;AACf;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".cart-container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 1.5rem;\n}\n\n.cart-container h1 {\n  margin-bottom: 1.5rem;\n  color: #24292e;\n  font-size: 1.75rem;\n  font-weight: 600;\n}\n\n.error-message {\n  background-color: #fee;\n  color: #c33;\n  padding: 10px 15px;\n  border-radius: 4px;\n  margin-bottom: 20px;\n}\n\n.success-message {\n  background-color: #efe;\n  color: #363;\n  padding: 20px;\n  border-radius: 4px;\n  margin-bottom: 20px;\n}\n\n.success-message h3 {\n  margin-top: 0;\n  color: #363;\n}\n\n.empty-cart {\n  text-align: center;\n  padding: 60px 20px;\n  color: #666;\n}\n\n/* Bundled Items Styling */\n.bundled-notice {\n  background: #f8f9fa;\n  border: 1px solid #dee2e6;\n  border-radius: 6px;\n  padding: 0.875rem 1rem;\n  margin-bottom: 1.25rem;\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n}\n\n.bundled-notice i {\n  color: #6c757d;\n  font-size: 1.1rem;\n  margin-top: 2px;\n}\n\n.bundled-notice-content {\n  flex: 1;\n}\n\n.bundled-notice-title {\n  font-weight: 600;\n  color: #495057;\n  margin-bottom: 0.25rem;\n  font-size: 0.95rem;\n}\n\n.bundled-notice-text {\n  color: #6c757d;\n  font-size: 0.85rem;\n  margin: 0;\n  line-height: 1.4;\n}\n\n/* Bundled Item Card */\n.card.bundled-item {\n  background: #fafbfc !important;\n  border: 1px solid #e1e4e8 !important;\n  border-left: 3px solid #6c757d !important;\n  margin-left: 0.5rem;\n}\n\n.bundled-badge {\n  background: #6c757d !important;\n  color: white !important;\n  font-size: 0.7rem;\n  padding: 0.2rem 0.4rem;\n  border-radius: 3px;\n  font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.bundled-info {\n  color: #6c757d;\n  font-size: 0.8rem;\n  font-style: normal;\n  opacity: 0.9;\n}\n\n/* Table row for bundled items */\ntr.bundled-row {\n  background-color: #fafbfc !important;\n}\n\ntr.bundled-row td {\n  border-left: none;\n  padding-left: 2rem;\n  position: relative;\n}\n\ntr.bundled-row td:first-child::before {\n  content: \"\";\n  position: absolute;\n  left: 0.75rem;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 3px;\n  height: 60%;\n  background: #6c757d;\n  border-radius: 2px;\n}\n\n/* Fix yellow-on-yellow issue */\n.badge.bg-warning {\n  background-color: #495057 !important;\n  color: white !important;\n}\n\n.table-warning {\n  background-color: #f8f9fa !important;\n}\n\n.border-warning {\n  border-color: #dee2e6 !important;\n}\n\n/* Checkout/Draft Info Box */\n.checkout-info-box {\n  background-color: #f8f9fa;\n  border: 1px solid #e1e4e8;\n  border-radius: 6px;\n  padding: 0.875rem 1rem;\n  margin-top: 0.75rem;\n}\n\n.checkout-info-content {\n  font-size: 0.8rem;\n  color: #586069;\n  line-height: 1.5;\n}\n\n.checkout-info-row {\n  display: flex;\n  align-items: flex-start;\n  margin-bottom: 0.4rem;\n  gap: 0.5rem;\n}\n\n.checkout-info-row:last-child {\n  margin-bottom: 0;\n}\n\n.checkout-info-label {\n  min-width: 70px;\n  font-weight: 600;\n  color: #24292e;\n  font-size: 0.8rem;\n}\n\n.checkout-info-text {\n  flex: 1;\n  color: #586069;\n  font-size: 0.8rem;\n}\n\n.cart-items {\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n  margin-bottom: 20px;\n}\n\n.cart-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px;\n  border-bottom: 1px solid #eee;\n}\n\n.cart-item:last-child {\n  border-bottom: none;\n}\n\n.item-info h3 {\n  margin: 0 0 8px 0;\n  color: #333;\n}\n\n.item-info p {\n  margin: 4px 0;\n  color: #666;\n  font-size: 14px;\n}\n\n.item-info .price {\n  color: #1976d2;\n  font-weight: 500;\n}\n\n.item-controls {\n  display: flex;\n  align-items: center;\n  gap: 30px;\n}\n\n.quantity-controls {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.quantity-controls button {\n  width: 30px;\n  height: 30px;\n  border: 1px solid #ddd;\n  background: white;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 18px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.quantity-controls button:hover:not(:disabled) {\n  background-color: #f5f5f5;\n}\n\n.quantity-controls button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.quantity {\n  min-width: 40px;\n  text-align: center;\n  font-weight: 500;\n}\n\n.item-subtotal {\n  min-width: 100px;\n  text-align: right;\n  font-weight: 500;\n  font-size: 18px;\n  color: #333;\n}\n\n.remove-btn {\n  background: none;\n  border: none;\n  color: #c33;\n  cursor: pointer;\n  padding: 5px 10px;\n  text-decoration: underline;\n}\n\n.remove-btn:hover {\n  color: #a22;\n}\n\n.cart-summary {\n  background: white;\n  border-radius: 6px;\n  border: 1px solid #e1e4e8;\n  box-shadow: 0 1px 3px rgba(0,0,0,0.06);\n  padding: 1.25rem;\n  max-width: 400px;\n  margin-left: auto;\n}\n\n.summary-row {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 10px;\n  color: #666;\n}\n\n.summary-row.total {\n  margin-top: 20px;\n  padding-top: 20px;\n  border-top: 2px solid #eee;\n  font-size: 20px;\n  font-weight: 500;\n  color: #333;\n}\n\n.cart-actions {\n  margin-top: 30px;\n}\n\n.create-quote-btn {\n  width: 100%;\n  padding: 0.625rem 1rem;\n  background-color: #0066cc;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  font-size: 0.9rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.create-quote-btn:hover {\n  background-color: #0052a3;\n  box-shadow: 0 2px 4px rgba(0,102,204,0.2);\n}\n\n/* Modal Styles */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.modal-content {\n  background: white;\n  padding: 30px;\n  border-radius: 8px;\n  max-width: 500px;\n  width: 90%;\n  max-height: 90vh;\n  overflow-y: auto;\n}\n\n.modal-content h2 {\n  margin-top: 0;\n  margin-bottom: 20px;\n  color: #333;\n}\n\n.form-group {\n  margin-bottom: 20px;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 8px;\n  color: #666;\n  font-weight: 500;\n}\n\n.form-group textarea {\n  width: 100%;\n  padding: 10px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  resize: vertical;\n  font-family: inherit;\n}\n\n.modal-actions {\n  display: flex;\n  gap: 10px;\n  justify-content: flex-end;\n  margin-top: 30px;\n}\n\n.modal-actions button {\n  padding: 10px 20px;\n  border: 1px solid #ddd;\n  background: white;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n}\n\n.modal-actions button.primary {\n  background-color: #1976d2;\n  color: white;\n  border-color: #1976d2;\n}\n\n.modal-actions button:hover:not(:disabled) {\n  opacity: 0.9;\n}\n\n.modal-actions button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.loading {\n  text-align: center;\n  padding: 40px;\n  color: #666;\n}\n\n.error {\n  text-align: center;\n  padding: 40px;\n  color: #c33;\n}\n\n/* Inline Quantity Editor Styles */\n.quantity-edit-wrapper {\n  position: relative;\n}\n\n.quantity-edit-wrapper .input-group {\n  box-shadow: 0 2px 8px rgba(0,0,0,0.15);\n  border-radius: 4px;\n  overflow: hidden;\n}\n\n.quantity-edit-wrapper input[type=\"number\"] {\n  border-right: none;\n  font-weight: 500;\n  font-size: 16px;\n}\n\n.quantity-edit-wrapper input[type=\"number\"]:focus {\n  box-shadow: none;\n  border-color: #1976d2;\n}\n\n.quantity-edit-wrapper .btn-success {\n  border-left: 1px solid #e0e0e0;\n  border-radius: 0;\n}\n\n.quantity-edit-wrapper .btn-secondary {\n  border-left: 1px solid #e0e0e0;\n  border-radius: 0 4px 4px 0;\n}\n\n.quantity-display {\n  cursor: pointer;\n  padding: 4px 12px;\n  border-radius: 4px;\n  transition: all 0.2s ease;\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  user-select: none;\n}\n\n.quantity-display:hover {\n  background-color: #f0f0f0;\n  box-shadow: 0 1px 3px rgba(0,0,0,0.1);\n}\n\n.quantity-display .fa-edit {\n  opacity: 0;\n  transition: opacity 0.2s;\n}\n\n.quantity-display:hover .fa-edit {\n  opacity: 0.7;\n}\n\n.quantity-updating {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 60px;\n  padding: 4px 12px;\n}\n\n/* Product Link Styles */\n.cart-product-link {\n  text-decoration: none;\n  transition: all 0.2s ease;\n}\n\n.cart-product-link:hover {\n  text-decoration: underline;\n  opacity: 0.85;\n}\n\n.cart-product-link h6 {\n  transition: color 0.2s ease;\n}\n\n.cart-product-link:hover h6 {\n  color: #1565c0 !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
